export const utils = {
    regexForId: /^[A-Za-z0-9_]{6,12}$/,
    regexForPassword: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/])[A-Za-z\d!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/]{8,}$/,
    regexForEmail: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    regexForPhone: /^01[016789]-?\d{3,4}-?\d{4}$/,
    regexForBirth: /^(19[0-9]{2}|20[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/,
    isValidDate: (dateStr: string) => {
        // YYYYMMDD 형식 체크
        if (!utils.regexForBirth.test(dateStr)) {
            return false;
        }

        const year = parseInt(dateStr.substring(0, 4), 10);
        const month = parseInt(dateStr.substring(4, 6), 10);
        const day = parseInt(dateStr.substring(6, 8), 10);

        // 실제 존재하는 날짜인지 체크
        const date = new Date(year, month - 1, day);
        return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    },
    imgRender: (files: any, imgUrl: any) => {
        const file = files[0];
        let imgUrls = imgUrl;
        // FileReader 객체 : 웹 애플리케이션이 데이터를 읽고, 저장하게 해줌
        const reader = new FileReader();

        // load 이벤트 핸들러. 리소스 로딩이 완료되면 실행됨.
        reader.onload = (ee: any) => {
            imgUrls = ee.target.result;
        }; // ref previewImage 값 변경

        // 컨텐츠를 특정 file에서 읽어옴. 읽는 행위가 종료되면 loadend 이벤트 트리거함
        // & base64 인코딩된 스트링 데이터가 result 속성에 담김
        reader.readAsDataURL(file);
    },
    getImgUrl: (file: File) => {
        return URL.createObjectURL(file);
    },

    numberFormat: (number: number | string) => {
        try {
            let formatNum;
            if (number) {
                if (typeof number === "number") {
                    formatNum = number.toString();
                } else {
                    formatNum = number;
                }
                return formatNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return 0;
            }
        } catch (error) {
            // console.warn("숫자 변환 실패 값 :", number);
            return 0;
        }
    },

    formatDate: (isoDateString: string): string => {
        const date = new Date(isoDateString);

        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);

        const formattedDateString = `${year}.${month}.${day} ${hours}:${minutes}`;

        return formattedDateString;
    },
    dateFormat: (selectDate: number | string | Date, format: string | null, isShowHour: boolean) => {
        let date: Date;
        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                const hour = parseInt(selectDate.substring(8, 10), 10);
                const minute = parseInt(selectDate.substring(8, 10), 10);
                const second = parseInt(selectDate.substring(8, 10), 10);

                date = new Date(year, month, day, hour, minute, second);
            } else if (typeof selectDate === "number") {
                date = new Date(selectDate);
            } else {
                date = selectDate;
            }
            const formattedYear: number = date.getFullYear();
            let formattedMonth: number | string = date.getMonth() + 1;
            formattedMonth = formattedMonth < 10 ? "0" + formattedMonth : formattedMonth.toString();
            let formattedDay: number | string = date.getDate();
            formattedDay = formattedDay < 10 ? "0" + formattedDay : formattedDay.toString();

            let formattedHour: number | string = date.getHours();
            formattedHour = formattedHour < 10 ? "0" + formattedHour : formattedHour.toString();
            let formattedMinute: number | string = date.getMinutes();
            formattedMinute = formattedMinute < 10 ? "0" + formattedMinute : formattedMinute.toString();
            let formattedSecond: number | string = date.getSeconds();
            formattedSecond = formattedSecond < 10 ? "0" + formattedSecond : formattedSecond.toString();

            const divFormat = format === null ? "-" : format;

            let resultDate = `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay}`;

            if (isShowHour) resultDate = resultDate + ` ${formattedHour}:${formattedMinute}:${formattedSecond}`;

            return resultDate;
        } else {
            return "";
        }
    },

    dateFormatYY: (selectDate: number | string | Date, format: string | null) => {
        let date: Date;
        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else if (typeof selectDate === "number") {
                const dateString = selectDate.toString();
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1;
                const day = parseInt(dateString.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else {
                date = selectDate;
            }

            const formattedYear: string = date.getFullYear().toString().slice(2);
            let formattedMonth: string = (date.getMonth() + 1).toString().padStart(2, "0");
            let formattedDay: string = date.getDate().toString().padStart(2, "0");
            const divFormat = format === null ? "-" : format;

            return `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay}`;
        } else {
            return "";
        }
    },
    dateFormatYYMM: (selectDate: number | string | Date, format: string | null = ".") => {
        let date: Date;

        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = 1;

                date = new Date(year, month, day);
            } else if (typeof selectDate === "number") {
                const dateString = selectDate.toString();
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1;
                const day = 1;

                date = new Date(year, month, day);
            } else {
                date = selectDate;
            }

            const formattedYear: string = date.getFullYear().toString();
            const formattedMonth: string = (date.getMonth() + 1).toString().padStart(2, "0");

            const divFormat = format ?? ".";

            return `${formattedYear}${divFormat}${formattedMonth}`;
        } else {
            return "";
        }
    },
    dateFormatYYMMDD: (selectDate: number | string | Date, format: string | null = ".") => {
        let date: Date;

        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else if (typeof selectDate === "number") {
                const dateString = selectDate.toString();
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1;
                const day = parseInt(dateString.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else {
                date = selectDate;
            }

            const formattedYear: string = date.getFullYear().toString().slice(2);
            const formattedMonth: string = (date.getMonth() + 1).toString().padStart(2, "0");
            const formattedDay: string = date.getDate().toString().padStart(2, "0");

            const divFormat = format ?? ".";

            return `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay}`;
        } else {
            return "";
        }
    },
    dateFormatYYMMDDDay: (selectDate: number | string | Date, format: string | null = ".") => {
        let date: Date;
        const days = ["일", "월", "화", "수", "목", "금", "토"];

        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else if (typeof selectDate === "number") {
                const dateString = selectDate.toString();
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1;
                const day = parseInt(dateString.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else {
                date = selectDate;
            }

            const formattedYear: string = date.getFullYear().toString().slice(2);
            const formattedMonth: string = (date.getMonth() + 1).toString().padStart(2, "0");
            const formattedDay: string = date.getDate().toString().padStart(2, "0");

            const divFormat = format ?? ".";

            return `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay} (${days[date.getDay()]})`;
        } else {
            return "";
        }
    },
    convertEmail: (email: string) => {
        if (!email || !email.includes("@")) {
            return { id: "", domain: "" };
        }

        const [id, domain] = email.split("@");
        return { id, domain };
    },
    convertPhoneNum: (phoneNum: string) => {
        if (!phoneNum) {
            return { phoneNum1: "", phoneNum2: "", phoneNum3: "" };
        } else {
            const strPhoneNum = phoneNum.replace(/\D/g, "");

            return {
                phoneNum1: strPhoneNum.slice(0, 3) || "",
                phoneNum2: strPhoneNum.slice(3, 7) || "",
                phoneNum3: strPhoneNum.slice(7, 11) || "",
            };
        }
    },

    convertPhoneNumReal: (phoneNum: string) => {
        if (!phoneNum) {
            return { phoneNum1: "", phoneNum2: "", phoneNum3: "" };
        } else {
            const strPhoneNum = phoneNum.replace(/\D/g, "");

            return strPhoneNum.slice(0, 3) + "-" + strPhoneNum.slice(3, 7) + "-" + strPhoneNum.slice(7, 11);
        }
    },
    checkImageSrc: (url: string) => {
        return new Promise((resolve) => {
            const img = new Image();

            img.onload = () => resolve(true); // 이미지가 정상적으로 로드된 경우
            img.onerror = () => resolve(false); // 이미지 로드에 실패한 경우

            img.src = url;
        });
    },

    makeBoundary: () => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let boundary = "----WebKitFormBoundary"; // WebKit 스타일 prefix
        for (let i = 0; i < 16; i++) {
            boundary += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return boundary;
    },
    decodeContent: (encoded: string) => {
        try {
            if (encoded) {
                // 1. URL 디코딩
                let base64 = decodeURIComponent(encoded);

                // 2. URL-safe Base64를 일반 Base64로 변환
                base64 = base64.replace(/-/g, "+").replace(/_/g, "/");

                // 3. 길이 맞추기 (4의 배수가 아니면 = 추가)
                while (base64.length % 4) {
                    base64 += "=";
                }

                // 이미 정상문자인 경우 return
                try {
                    atob(base64);
                } catch {
                    return encoded;
                }

                // 4. atob → binary string
                const binaryString = atob(base64);

                // 5. binary string → Uint8Array
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                // 6. TextDecoder로 UTF-8 변환
                const decoder = new TextDecoder("utf-8");
                return decoder.decode(bytes);
            } else return encoded;
        } catch (error) {
            console.error("디코딩 실패:", error);
            return encoded;
        }
    },
    encodeContent: (str: string) => {
        const encoder = new TextEncoder();
        const bytes = encoder.encode(str);

        // Uint8Array → binary string
        let binary = "";
        bytes.forEach((b) => (binary += String.fromCharCode(b)));

        // binary string → Base64 → URL-safe
        return encodeURIComponent(btoa(binary));
    },
    htmlToText: (html: string) => {
        const div = document.createElement("div");
        div.innerHTML = html;

        return div.innerText;
    },
    allFocusOut: () => {
        const activeElement = document.activeElement as HTMLElement | null;
        if (activeElement) activeElement.blur();
    },
    errorImg: (event: Event) => {
        const target = event.target as HTMLImageElement;
        target.src = require("@/assets/no_img.png");
    },
};
